import { useEffect, useState } from "react";
import { Button, Col, Flex, Row, Space, Table, Tag, Tooltip, Typography } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { showNotificationTopEnd } from "../../../../util/utils";
import { callCreateDashboardMetaTemplate, callGetDashboardMetaTemplates, callUpdateDashboardMetaTemplate } from "../../../../services/templatesService";
import { DASHBOARD_META_TEMPLATE } from "../../../../constants/AppConstants";

import MetaTemplateModalForm from "../MetaTemplateModalForm/MetaTemplateModalForm";

const { Title } = Typography;

export default function MetaTemplateList() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [modalCreateVisible, setModalCreateVisible] = useState(false);
    const [reload, setReload] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });


    useEffect(() => {
        getMetaTemplates(pagination.current - 1, pagination.pageSize);
        // eslint-disable-next-line
    }, [reload]);


    const getMetaTemplates = async (page, size) => {
        setLoading(true);

        const response = await callGetDashboardMetaTemplates(page, size);
        if (response?.status === 200) {
            setData(response.data.content);
            setPagination({
                current: page + 1,
                pageSize: size,
                total: response.data?.page?.totalElements,
            });
        } else {
            showNotificationTopEnd("error", "Error, por favor recarga la pagina");
        }
        setLoading(false);
    };


    const handleTableChange = (pagination) => {
        getMetaTemplates(pagination.current - 1, pagination.pageSize);
    };


    const handleEdit = (record) => {
        setSelectedRecord(record);
        setModalCreateVisible(true);
    };


    const columns = [
        {
            title: DASHBOARD_META_TEMPLATE.COLUMNS.ID,
            dataIndex: "templateMetaId",
            key: "templateMetaId",
            width: 80,
        },
        {
            title: DASHBOARD_META_TEMPLATE.COLUMNS.TEMPLATE_NAME,
            dataIndex: "templateName",
            key: "templateName",
        },
        {
            title: DASHBOARD_META_TEMPLATE.COLUMNS.CATEGORY,
            dataIndex: "category",
            key: "category",
        },
        {
            title: DASHBOARD_META_TEMPLATE.COLUMNS.LANGUAGE,
            dataIndex: "language",
            key: "language",
        },
        {
            title: DASHBOARD_META_TEMPLATE.COLUMNS.ACTION_TYPE,
            dataIndex: "action",
            key: "action",
        },
        {
            title: DASHBOARD_META_TEMPLATE.COLUMNS.AMOUNT_CHARACTERS,
            dataIndex: "amountCharacters",
            key: "amountCharacters",
            width: 150,
        },
        {
            title: DASHBOARD_META_TEMPLATE.COLUMNS.MAX_CHARACTERS,
            dataIndex: "maxCharacters",
            key: "maxCharacters",
            width: 150,
        },
        {
            title: DASHBOARD_META_TEMPLATE.COLUMNS.ONLY_TICKETS_ON_MESSAGE,
            dataIndex: "onlyTicketsOnMessage",
            key: "onlyTicketsOnMessage",
            width: 150,
            render: (value) =>
                value ? (
                    <Tag color="cyan">Solo tickets</Tag>
                ) : (
                    <Tag color="volcano">Con subtickets</Tag>
                ),
        },
        {
            title: DASHBOARD_META_TEMPLATE.COLUMNS.STATUS,
            dataIndex: "active",
            key: "active",
            render: (value) =>
                value ? (
                    <Tag color="green">{DASHBOARD_META_TEMPLATE.STATUS.ACTIVE}</Tag>
                ) : (
                    <Tag color="red">{DASHBOARD_META_TEMPLATE.STATUS.INACTIVE}</Tag>
                ),
        },
        {
            title: DASHBOARD_META_TEMPLATE.COLUMNS.ACTIONS,
            key: "active",
            render: (_, record) => (
                <Space>
                    <Tooltip title={DASHBOARD_META_TEMPLATE.ACTIONS.TOOLTIPS.EDIT}>
                        <Button
                            shape="circle"
                            icon={<EditOutlined />}
                            type="primary"
                            onClick={() => handleEdit(record)}
                        />
                    </Tooltip>
                </Space>
            ),
        },
    ];


    return (
        <Flex vertical>
            <Row
                gutter={[16, 16]}
                justify="space-between"
                align="middle"
                style={{ marginBottom: 24 }}
            >
                <Col span="auto">
                    <Title level={3}>{DASHBOARD_META_TEMPLATE.TITLE}</Title>
                </Col>
                <Col span="auto">
                    <Button
                        color="green"
                        variant="solid"
                        onClick={() => setModalCreateVisible(true)}
                    >
                        {DASHBOARD_META_TEMPLATE.ACTIONS.CREATE_TITLE}
                    </Button>
                    <MetaTemplateModalForm
                        visible={modalCreateVisible}
                        onClose={() => {
                            setModalCreateVisible(false);
                            setSelectedRecord(null);
                            setReload(!reload);
                        }}
                        initialValues={selectedRecord}
                        onSubmit={(values) =>
                            selectedRecord
                                ? callUpdateDashboardMetaTemplate(values)
                                : callCreateDashboardMetaTemplate(values)
                        }
                    />
                </Col>
            </Row>
            <Table
                columns={columns}
                dataSource={data}
                rowKey="templateMetaId"
                pagination={pagination}
                loading={loading}
                onChange={handleTableChange}
            />
        </Flex>
    );
}